import React from "react";
import {cn} from "@/lib/utils.ts";

const FormHeader = React.forwardRef<
    HTMLParagraphElement,
    React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => {
    return (
        <p
            ref={ref}
            className={cn("md:os-col-span-2 os-font-bold os-text-sm", className)}
            {...props}
        />
    )
})
FormHeader.displayName = "FormHeader"
export default FormHeader;